import styled from 'styled-components';
import { colors, spaces } from '@99designs/emu/settings';

export interface CarouselStepsProps {
    count: number;
    currentIndex: number;
    onClick: (stepIndex: number) => void;
}

const Container = styled.div`
    white-space: nowrap;
`;

const Step = styled.div<{ active: boolean }>`
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 20px;
    cursor: pointer;
    margin-left: ${spaces['1bu']};
    background: ${({ active }) => (active ? colors.grey700 : colors.grey300)};

    :first-child {
        margin-left: 0;
    }
`;

export function CarouselSteps({ count, currentIndex, onClick }: CarouselStepsProps) {
    return (
        <Container>
            {[...Array(count).keys()].map((stepIndex) => (
                <Step
                    key={stepIndex}
                    active={currentIndex === stepIndex}
                    onClick={() => onClick(stepIndex)}
                />
            ))}
        </Container>
    );
}
